import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import React from "react";
import { TextFieldBOValidate } from "../../../TextFieldBO/TextFieldBOValidate";

export const AdittionalData = ({ register, errors, watch }) => {
  const { description } = watch() || {};

  return (
    <Box>
      <Accordion>
        <AccordionSummary
          expandIcon={<CaretDown size={32} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography fontWeight={700} color={"primary"}>
            Información adiciónal
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextFieldBOValidate
            register={register}
            name="description"
            label={"Información adicional"}
            errors={errors}
            maxLength={300}
            length={description?.length}
            rows={4}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
